exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../node_modules/css-loader/dist/cjs.js!vuetify/dist/vuetify.min.css"), "");

// Module
exports.push([module.id, ".container {\n  padding: 0px;\n}\n", ""]);

